// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"join-others-wrapper_wrapper__5oIqc"};